import DatasetTable from "datasets/pages/tables/pages/DatasetTable";

export const DatasetTableDetail = () => <DatasetTable />;
